





















































































































































































































































































































































































































































































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import DetailsImg from '@/app/components/FieldDetails/Details/DetailsImg.vue'
/* module */
import { sensorData } from '@/app/model/store/domain/types'
import DateClass from '@/app/module/date'
import Session from '@/app/module/session'
import { routerPath, harvestStatus } from '@/app/model/store/domain/const'
/* api */
import GetImageApi from '@/app/model/api/getImageApi'

@Component({
  components: {
    Loading,
    DetailsImg
  }
})
export default class DetailsContent extends Vue {
  private imgPath: string = ''
  private plantingId: number = 0
  private allGraphData: {[key: number]: any } = {}
  private graphData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0
  }
  private sensorDataList: any[] = []
  private sensorData: sensorData = {
    field_status: {
      human_problem: false,
      pest: false,
      sickness: false,
      water_control: false,
      weeds: false
    },
    growth_stage: '-',
    growth_step: '-',
    growth_status: {
      growth_height: '-',
      stem_number: '-'
    },
    image_path: require('@/assets/icon/ico_barley_02.svg'),
    excluded_area_rate: '-',
    integration_temperature: '-',
    nutrition_status: {
      leaf_color: '-',
      spad: '-'
    },
    soil_status: {
      earth_temperature: '-',
      moisture: '-',
      ph: '-',
      earth_ec: '-'
    },
    weather_status: {
      humidity: '-',
      rainfall: '-',
      sunshine: '-',
      temperature: '-',
      weather: '-',
      wind_direction: '-',
      wind_velocity: '-'
    }
  }
  private keyDate: string = ''
  private getImgKey: string = ''
  private keyWeekDay: string = ''
  private isActiveSickness: boolean = false
  private isActiveWeeds: boolean = false
  private isActivePest: boolean = false
  private isActiveHumanProblem: boolean = false
  private isActiveWaterControl: boolean = false
  private showDetailLoading: boolean = true
  private showFutureData: boolean = false
  private btnDisabled: boolean = false
  private maxIntegrationTemperature: number = 0
  private disabled: boolean = false
  private destroyFlag: boolean = false
  /* アイコン */
  private stemIcon: string = require('@/assets/icon/ico_no_data.svg')
  private growthHeightIcon: string = require('@/assets/icon/ico_no_data.svg')
  private leafColorIcon: string = require('@/assets/icon/ico_no_data.svg')
  private spadIcon: string = require('@/assets/icon/ico_no_data.svg')
  private soilMoistureIcon: string = require('@/assets/icon/ico_no_data.svg')
  private phIcon: string = require('@/assets/icon/ico_no_data.svg')
  private earthTemperatureIcon: string = require('@/assets/icon/ico_no_data.svg')
  private growthImgPath: string = require('@/assets/icon/ico_barley_01.svg')
  private excludedAreaIcon: string = require('@/assets/icon/excluded_area_none.svg')

  @Prop() detailData!: any

  private get dateChangeState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  private get setSensorDataFlag () : boolean {
    return this.$store.state.setFlagState.sensorDataFlag
  }

  @Watch('dateChangeState')
  onDateChange (newValue: string) {
    if (newValue !== '') {
      this.displayDate(newValue)
      let plantingId = Session.getPlantingId()!

      /* 画像取得APIのためのkeyを保存 */
      this.getImgKey = newValue

      this.getDetailsData(newValue)
    }
  }
  @Watch('setSensorDataFlag')
  getFlag (flag: boolean) {
    if (flag) {
      this.getSensorData()
      /* フラグリセット */
      this.$store.commit('setFlagState/setSensorDataFlag', false)
    }
  }

  created () {
    this.cacheClear()
    this.$store.commit('dateChoiceState/setChangeDate', '')
    this.$store.commit('setFlagState/setSensorDataFlag', false)
  }

  beforeDestroy () {
    this.destroyFlag = true
  }

  private async cacheClear () {
    await Session.clearSensorCache()
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  /* センサーデータをlocalStorageから取得 */
  private async getSensorData () {
    this.showDetailLoading = true
    let plantingId = Session.getPlantingId()!
    this.allGraphData = JSON.parse(Session.getGraphData()!)
    let sensorDataList: any = await Session.getSensorData(plantingId)!
    sensorDataList = JSON.parse(sensorDataList)

    if (sensorDataList !== null) {
      if (Object.keys(sensorDataList).length === 1) {
        // timestamp以外のデータがないとき
        this.keyDate = '-月-日'
        this.keyWeekDay = '-'
        this.showDetailLoading = false
        this.disabled = true
      } else if (sensorDataList !== null) {
        this.sensorDataList = JSON.parse(Session.getSensorData(plantingId)!)
      }
      this.getGraphData()
    }
  }

  private getGraphData () {
    /* 取得したデータの最新、または、グラフの最終日を表示 */
    let dataLastDate: string = String(Object.keys(this.allGraphData).pop())
    let graphLastDate: number = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let keyDate: string

    if (parseInt(dataLastDate) > graphLastDate) {
      keyDate = String(graphLastDate)
    } else {
      keyDate = dataLastDate
    }
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
    this.displayDate(keyDate)

    if (this.allGraphData !== null) {
      if (Object.keys(this.allGraphData).length !== 0) {
        this.getDaysTodate(keyDate)
        let plantingId = Session.getPlantingId()!

        /* 詳細データがある場合は表示 */
        if (this.allGraphData[parseInt(keyDate)]) {
          this.graphData = this.allGraphData[parseInt(keyDate)]
          this.getDetailsData(keyDate)
        } else {
          this.getDetailsData(keyDate)
        }
      }
    }

    this.showDetailLoading = false
  }

  /* 播種日からkeyDateまでの日数を取得 */
  private getDaysTodate (keyDate: string) {
    let plantingDay: number = parseInt(Session.getPlantingDay()!)
    this.$store.commit('fieldDetailsState/setdaysToDate', DateClass.daysCalculation(plantingDay, parseInt(keyDate)))
  }

  /* センサーデータ取得 */
  private getDetailsData (key:string) {
    this.sensorData = {
      field_status: {
        human_problem: false,
        pest: false,
        sickness: false,
        water_control: false,
        weeds: false
      },
      growth_stage: '-',
      growth_step: '-',
      growth_status: {
        growth_height: '-',
        stem_number: '-'
      },
      image_path: '',
      excluded_area_rate: '-',
      integration_temperature: '-',
      nutrition_status: {
        leaf_color: '-',
        spad: '-'
      },
      soil_status: {
        earth_temperature: '-',
        moisture: '-',
        ph: '-',
        earth_ec: '-'
      },
      weather_status: {
        humidity: '-',
        rainfall: '-',
        sunshine: '-',
        temperature: '-',
        weather: '-',
        wind_direction: '-',
        wind_velocity: '-'
      }
    }

    for (var j in this.sensorDataList) {
      if (String(this.sensorDataList[j].date) === String(key)) {
        this.maxIntegrationTemperature = this.sensorDataList[j].max_intergration_temperature
        this.sensorData = this.sensorDataList[j]
      }
    }
    // データが無かったら表示
    if (this.sensorData.growth_stage === '-') {
      this.showFutureData = true
    } else {
      this.showFutureData = false
    }

    Session.setFieldId(JSON.stringify(this.$route.params.field_id))
    this.judgmentWorning()
    this.judgmentIconColor()
    this.judgmentGrowthImg()
    this.displayExcludedArea()
    this.setImagePath()
  }

  /* 日付と曜日の表示 */
  private displayDate (keyDate: string) {
    if (keyDate === '') {
      this.keyDate = ''
      this.keyWeekDay = ''
    } else {
      this.keyDate = DateClass.displayData(parseInt(keyDate))
      this.keyWeekDay = DateClass.setWeek(parseInt(keyDate))
    }
  }

  /* 画像日時 */
  private async setImagePath () {
    let date = '' + new Date().getFullYear() + (new Date().getMonth() + 1) + (new Date().getDate() - 1)
    this.imgPath = String(this.keyDate)
  }

  /* 圃場状態アイコンの判定 */
  private judgmentWorning () {
    if (this.sensorData.field_status.sickness) {
      this.isActiveSickness = true
    } else {
      this.isActiveSickness = false
    }

    if (this.sensorData.field_status.weeds) {
      this.isActiveWeeds = true
    } else {
      this.isActiveWeeds = false
    }

    if (this.sensorData.field_status.pest) {
      this.isActivePest = true
    } else {
      this.isActivePest = false
    }

    if (this.sensorData.field_status.human_problem) {
      this.isActiveHumanProblem = true
    } else {
      this.isActiveHumanProblem = false
    }

    if (this.sensorData.field_status.water_control) {
      this.isActiveWaterControl = true
    } else {
      this.isActiveWaterControl = false
    }
  }

  /* 詳細アイコンの判定 */
  private judgmentIconColor () {
    /* 茎数 */
    if (this.sensorData.growth_status.stem_number > 0) {
      this.stemIcon = require('@/assets/icon/ico_status_normal.svg')
    } else {
      this.stemIcon = require('@/assets/icon/ico_no_data.svg')
    }

    /* 草丈 */
    if (this.sensorData.growth_status.growth_height > 0) {
      this.growthHeightIcon = require('@/assets/icon/ico_status_normal.svg')
    } else {
      this.growthHeightIcon = require('@/assets/icon/ico_no_data.svg')
    }

    /* 葉色 */
    if (this.sensorData.nutrition_status.leaf_color > 0) {
      this.leafColorIcon = require('@/assets/icon/ico_status_normal.svg')
    } else {
      this.leafColorIcon = require('@/assets/icon/ico_no_data.svg')
    }

    /* SPAD */
    if (this.sensorData.nutrition_status.spad > 0) {
      this.spadIcon = require('@/assets/icon/ico_status_normal.svg')
    } else {
      this.spadIcon = require('@/assets/icon/ico_no_data.svg')
    }

    /* ph */
    if (this.sensorData.soil_status.ph === null || this.sensorData.soil_status.ph === '-') {
      this.phIcon = require('@/assets/icon/ico_no_data.svg')
    } else if (this.sensorData.soil_status.ph >= 7.0) {
      this.phIcon = require('@/assets/icon/ico_ph59-.svg')
    } else if (this.sensorData.soil_status.ph >= 6.1 && this.sensorData.soil_status.ph <= 6.9) {
      this.phIcon = require('@/assets/icon/ico_ph54-59.svg')
    } else {
      this.phIcon = require('@/assets/icon/ico_ph-54.svg')
    }

    /* 地温(数値仮) */
    if (this.sensorData.soil_status.earth_temperature === null || this.sensorData.soil_status.earth_temperature === '-') {
      this.earthTemperatureIcon = require('@/assets/icon/ico_no_data.svg')
    } else if (this.sensorData.soil_status.earth_temperature <= 5) {
      // 注意
      this.earthTemperatureIcon = require('@/assets/img/ico_status_precautions.png')
    } else if (this.sensorData.soil_status.earth_temperature >= 80) {
      // 危険
      this.earthTemperatureIcon = require('@/assets/icon/ico_status_danger.svg')
    } else {
      // 正常
      this.earthTemperatureIcon = require('@/assets/icon/ico_status_normal.svg')
    }

    /* 土壌EC */
    if (this.sensorData.soil_status.earth_ec === null || this.sensorData.soil_status.earth_ec === '-') {
      this.soilMoistureIcon = require('@/assets/icon/ico_no_data.svg')
    } else {
      this.soilMoistureIcon = require('@/assets/icon/ico_status_normal.svg')
    }
  }

  /* 大麦若葉育成の画像判定 */
  private judgmentGrowthImg () {
    if (this.sensorData.growth_step === 0) {
      let lastData = this.sensorDataList[this.sensorDataList.length - 1]
      if (lastData !== undefined) {
        this.sensorData.growth_step = lastData.growth_step
      }
    }

    if (this.sensorData.growth_step === 1) {
      this.growthImgPath = require('@/assets/icon/ico_barley_01.svg')
    } else if (this.sensorData.growth_step === 2) {
      this.growthImgPath = require('@/assets/icon/ico_barley_02.svg')
    } else {
      this.growthImgPath = require('@/assets/icon/ico_barley_03.svg')
    }
  }

  private displayExcludedArea () {
    if (this.sensorData.excluded_area_rate === 0) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_blue.svg')
    } else if (this.sensorData.excluded_area_rate !== null && this.sensorData.excluded_area_rate < 20) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_yellow.svg')
    } else if (this.sensorData.excluded_area_rate !== null && this.sensorData.excluded_area_rate >= 20) {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_red.svg')
    } else {
      this.excludedAreaIcon = require('@/assets/icon/excluded_area_none.svg')
    }
  }
  /* 日付変更用(<、>ボタンクリック時) */
  private changeDetailDate (type: string) {
    const plantingDay = parseInt(Session.getPlantingDay()!)
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const selectedDate = DateClass.formingDate(this.$store.state.dateChoiceState.changeDate)

    // 始まりを播種日-10日にする
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 10)
    const formingDate = this.formingData(minDay)

    const formingLastDate = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let maxDay = formingLastDate

    if (type === 'plus') {
      /* 現在の日付を時間に単位変換し、プラス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() + 1 * 24 * 60 * 60 * 1000)
      /* 数値型に変換 */
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 最終日より先の日付には変更不可 */
      if (setDate <= maxDay) {
        /* スライドバーを連動 */
        this.getDaysTodate(JSON.stringify(setDate))
        /* stateに保持 */
        this.$store.commit('dateChoiceState/setArrowClick', true)
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    } else if (type === 'minus') {
      /* 現在の日付を時間に単位変換し、マイナス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() - 1 * 24 * 60 * 60 * 1000)
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 播種日より前の日付は変更不可 */
      if (formingDate < setDate) {
        this.getDaysTodate(JSON.stringify(setDate))
        this.$store.commit('dateChoiceState/setArrowClick', true)
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    }
  }

  private formingData (day: any) {
    const date = DateClass.toDoubleDigits(day.getFullYear()) + DateClass.toDoubleDigits(day.getMonth() + 1) + DateClass.toDoubleDigits(day.getDate())
    return parseInt(date)
  }

  /* 最大値の判定 */
  public judgeMaxDay (a: number, b:number) {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  /* 小数点第二位以下切り上げ表示 */
  private displayTranslation (num: any) {
    if (num === null || num === undefined || num === '-') {
      return '-'
    } else {
      return Math.ceil(num * Math.pow(10, 2)) / Math.pow(10, 2)
    }
  }
}
